import { configureRequest, replacePathVariables } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  CancelOfferRequestForAdminErrorResponse,
  CancelOfferRequestForAdminRequest,
  CancelOfferRequestForAdminSuccessResponse
} from './cancelOfferRequestForAdmin.types'

export const cancelOfferRequestForAdminApi = async (
  request: CancelOfferRequestForAdminRequest
): Promise<CancelOfferRequestForAdminSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.admin.cancelOfferRequestForAdmin, {
      offerRequestId: request.offerRequestId
    }),
    method: 'POST',
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as CancelOfferRequestForAdminSuccessResponse
  } else {
    throw response as CancelOfferRequestForAdminErrorResponse
  }
}

export default cancelOfferRequestForAdminApi
